<template>
  <div class="page-iframes main-page">
    <div class="container-flex">
      <iframe :src="iframeSrc" width="100%" height="100%" id="ifra"></iframe>
      <div class="back-home" @click="$router.push('/')">
        <img src="/img/ui/back_home.png" alt="" srcset="">
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '../components/Menu'

export default {
  components: { Menus },
  computed: {
    iframeSrc () {
      const { urls } = this.$route.query
      return urls ? decodeURIComponent(urls) : ''
    },

  },
  mounted () {
    this.$nextTick(() => {
      this.$loading.show()
      const iframe = document.querySelector('#ifra')
      // 处理兼容行问题
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', () => {
          // iframe加载完毕以后执行操作
          console.log('iframe已加载完毕')
          this.$loading.hide()
        })
      } else {
        iframe.onload = () => {
          // iframe加载完毕以后执行操作
          this.$loading.hide()
          console.log('iframe已加载完毕')
        }
      }
    })
  }
}
</script>
<style lang="stylus" >
.page-iframes
  width 100%
  height 100vh
  display flex
  flex-direction column
  .container-flex
    flex 1
    .back-home
      position absolute
      right 0.3rem
      top 50%
      transform translateY(-50%)
      width 0.8rem
      height 0.8rem
      background-color #3574e5
      border-radius 50%
      display flex
      justify-content center
      align-items center
      img
        width 0.4rem
.page-iframes+ .control
  display none
</style>